import { createContext, useContext } from "react";

const CommentContext = createContext(null);

export const useCommentContext = () => {
  const context = useContext(CommentContext);
  if (!context) {
    throw new Error("useCommentContext must be used within a CommentContext.Provider");
  }
  return context;
};

export default CommentContext;
